import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

// Éléments modifiables en mode « Modifier la page » (admin) : la source/cible
// personnalisée est lue des réglages « site|<chemin> » ; sans personnalisation,
// la valeur du code est utilisée. En mode édition, le clic ouvre le mini-éditeur
// (InlineEditMode détecte data-edit-image / data-edit-link).

// Image modifiable : <EImg editPath="img.hero_bg" src={HERO_IMG} ... />
export function EImg({ editPath, src, ...rest }) {
  const { site } = useLang();
  return <img src={site(editPath) || src} data-edit-image={editPath} {...rest} />;
}

// Lien modifiable : interne (Link SPA) ou externe (<a href>) selon la cible —
// l'admin peut pointer un bouton vers une page du site ou une URL externe.
export function ELink({ editPath, to, children, ...rest }) {
  const { site } = useLang();
  const href = site(editPath) || to;
  const external = /^(https?:|mailto:|tel:)/i.test(href);
  return external
    ? <a href={href} data-edit-link={editPath} {...rest}>{children}</a>
    : <Link to={href} data-edit-link={editPath} {...rest}>{children}</Link>;
}
